module.exports = __webpack_public_path__ + "assets/svg/UI/education-plus-sign-0e2251.svg";